import { useState } from 'react';

// Custom hook for switching logic (used with left/right arrow like components)
export function useSwitcher(switcherItemCount: number, initialIdx?: number) {
  const [switcherIndex, setSwitcherIndex] = useState(initialIdx ?? 0);

  const increment = () => setSwitcherIndex((current) => Math.min(current + 1, switcherItemCount - 1));
  const decrement = () => setSwitcherIndex((current) => Math.max(current - 1, 0));

  return { switcherItemCount, switcherIndex, increment, decrement };
}
